import mutations from "@/store/mutations/coinMutaion";
import actions from "@/store/actions/coinAction";
import getters from "@/store/getters/coinGetter";
/**
 * [GX] SETTING DATA
 */
export default {
  state: {
    initTime: null,
    showDoubleCoinBubble: false,
    showSuperPayBubble: false,
    showSuperPayBubbleDate: null,
    superPayBubbleClick: false,
    isShowLimtedCoin: false,
    limitedCoinStr: "",
    limtedIntervalTime: 0,
    isShowLimtedCoinBubble: false,
    superPayRecommendClickDate: null
  },
  mutations,
  actions,
  getters
};
